<template>
  <section class="content">
    <header class="header">
      <a href="/" class="logo">
        <icon-logo-image class="logo__img" />
        <icon-logo-name class="logo__name" />
      </a>
    </header>
    <FilePreview />
  </section>
</template>

<script>
  import FilePreview from './FilePreview';

  import IconLogoImage from './content-icons/icon-logo-image.vue';
  import IconLogoName from './content-icons/icon-logo-name.vue';

  export default {
    name: 'Content',
    components: {
      IconLogoImage,
      IconLogoName,
      FilePreview
    }
  };
</script>

<style scoped lang="scss">
  @import 'src/scss/variables';

  .content {
    display: flex;
    position: relative;
    width: 61%;
    background: url('../assets/pattern.png') left bottom no-repeat;
    flex-direction: column;

    align-items: center;
    padding: 50px 25px;
    min-height: 100vh;

    @media screen and (max-width: 990px) {
      width: 100%;
    }
  }

  .header {
    width: 100%;
    max-width: 756px;
    margin: 34px auto 40px;

    @media (max-width: 768px) {
      margin-top: 0;
    }
  }

  .logo {
    display: inline-flex;
    align-items: center;

    &__name {
      margin-left: 24px;
    }
  }
</style>
